import { render, staticRenderFns } from "./WorksGather.vue?vue&type=template&id=e78d531c&scoped=true&"
import script from "./WorksGather.vue?vue&type=script&lang=js&"
export * from "./WorksGather.vue?vue&type=script&lang=js&"
import style0 from "./WorksGather.vue?vue&type=style&index=0&id=e78d531c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e78d531c",
  null
  
)

export default component.exports